import keys from '@debbie/common/dist/cache/keys.js';
import { genObjectKey } from '@debbie/common/dist/util/index.js';
import * as api from '../api/blame-logs.js';
import q from '../query.js';
export const blameLogsEntity = 'blame-logs';
const blameLogsKey = (refType, refId, filter, page, pageSize) => `blame-logs-${refType}-${refId}--${genObjectKey(filter)}-${page}-${pageSize}`;
export const useBlameLogs = (refType, refId, filter, page, pageSize) => q.query(blameLogsKey(refType, refId, filter, page, pageSize), () => api.getBlameLogs(refType, refId, filter, page, pageSize), keys.read.collection(blameLogsEntity));
//# sourceMappingURL=index.js.map